import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";
import { message } from "antd";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};



export const getSpecificProductAuditReport = (id) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/product/productaudit/${id}/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};


export const getSpecificProductAuditItem = (
  keyword = "",
  audit_health_stat = "",
  ProductAudit="",
  page = 1,
  page_size = 10,
) => async () => {
  try {
    const response = await backend.get(
      `api/product/productaudit-item?keyword=${keyword}&audit_health_stat=${audit_health_stat}&ProductAudit=${ProductAudit}&page=${page}&page_size=${page_size}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};


export const getSpecificProductAuditItemByTitle = (
  keyword = "",
  audit_health_stat = "",
  ProductAudit="",
  page = 1,
  page_size = 10,
) => async () => {
  try {
    const response = await backend.get(
      `api/product/productaudit-item-by-title?keyword=${keyword}&audit_health_stat=${audit_health_stat}&ProductAudit=${ProductAudit}&page=${page}&page_size=${page_size}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSpecificProductAuditItemExport = (
  keyword = "",
  audit_health_stat = "",
  ProductAudit="",
) => async () => {
  try {
    const response = await backend.get(
      `api/product/productaudit-item/export_excel/?keyword=${keyword}&audit_health_stat=${audit_health_stat}&ProductAudit=${ProductAudit}`,
      {
        ...getConfig(),
        responseType: 'blob',
      }
    );
    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'stock_audit_items.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSpecificProductAuditItemByTitleExport = (
  keyword = "",
  audit_health_stat = "",
  ProductAudit="",
) => async () => {
  try {
    const response = await backend.get(
      `api/product/productaudit-item-by-title/export_excel/?keyword=${keyword}&audit_health_stat=${audit_health_stat}&ProductAudit=${ProductAudit}`,
      {
        ...getConfig(),
        responseType: 'blob',
      }
    );
    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'stock_audit_by_title.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  } catch (error) {
    console.log(error);
  }
};
